import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';

export type Cashdesk = {
	id: number;
	name: string;
	balance: number;
	isLocked: boolean;
	currency: string;
	note: string | null;
	account: EntityWithName;
	cashiers: EntityWithName[];
};

export const cashdeskSchema: ZodType<Cashdesk> = z.object({
	id: z.number(),
	name: z.string(),
	isLocked: z.boolean(),
	balance: z.number(),
	currency: z.string(),
	note: z.string().nullable(),
	account: entityWithNameSchema,
	cashiers: entityWithNameSchema.array(),
});
